export { MB_Table } from './src/MB_Table';
export type { MB_TableProps } from './src/MB_Table';
